/** Distance from the viewport left edge — leaves room for the left toolbar. */
export const DOCK_LEFT = 60;

/** Width of the dock column. Matches the floating window default width. */
export const DOCK_PANEL_WIDTH = 352;

/** Vertical inset from the top/bottom of the render container. */
export const DOCK_EDGE_MARGIN = 8;

/** Gap between docked window slots. */
export const DOCK_PANEL_GAP = 8;

/** Fixed height of a minimized slot (header only). */
export const DOCK_MINIMIZED_HEIGHT = 58;

/** Minimum pinned height a slot can be dragged to. */
export const DOCK_MIN_HEIGHT = 120;

/** Height of the bottom-edge resize handle's hit area. */
export const DOCK_RESIZE_HANDLE_HEIGHT = 6;

/** z-index above the canvas, below modals. */
export const DOCK_Z_INDEX = 1100;
